(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-main"] && !Shopify.designMode) return;
  try {
    
  class CartMain {
    constructor() {
      this.form = document.querySelector('.cart-main__form');
      this.init();
    }

    init() {
      // Quantity buttons
      document.querySelectorAll('[data-quantity-minus]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const line = e.currentTarget.dataset.quantityMinus;
          const input = document.querySelector(`.cart-item__quantity-input[data-line="${line}"]`);
          const currentValue = parseInt(input.value);
          if (currentValue > 0) {
            input.value = currentValue - 1;
            this.updateCart();
          }
        });
      });

      document.querySelectorAll('[data-quantity-plus]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const line = e.currentTarget.dataset.quantityPlus;
          const input = document.querySelector(`.cart-item__quantity-input[data-line="${line}"]`);
          const currentValue = parseInt(input.value);
          input.value = currentValue + 1;
          this.updateCart();
        });
      });

      // Remove buttons
      document.querySelectorAll('[data-remove-item]').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const line = e.currentTarget.dataset.removeItem;
          const input = document.querySelector(`.cart-item__quantity-input[data-line="${line}"]`);
          input.value = 0;
          this.updateCart();
        });
      });
    }

    updateCart() {
      if (this.form) {
        this.form.submit();
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new CartMain();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FAQ {
    constructor() {
      this.items = document.querySelectorAll('.faq__question');
      this.init();
    }

    init() {
      this.items.forEach(button => {
        button.addEventListener('click', () => this.toggleItem(button));
      });
    }

    toggleItem(button) {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const answer = button.nextElementSibling;

      if (isExpanded) {
        button.setAttribute('aria-expanded', 'false');
        answer.style.maxHeight = null;
      } else {
        button.setAttribute('aria-expanded', 'true');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new FAQ();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class Header {
    constructor() {
      this.header = document.querySelector('.header');
      this.menuToggle = document.querySelector('.header__menu-toggle');
      this.mobileMenu = document.querySelector('.header__mobile-menu');
      this.menuClose = document.querySelector('.header__mobile-menu-close');
      this.searchToggle = document.querySelector('.header__search-toggle');
      this.searchContainer = document.querySelector('.header__search-container');
      this.searchClose = document.querySelector('.header__search-close');
      this.searchInput = document.querySelector('.header__search-input');

      this.init();
    }

    init() {
      // Handle scroll for transparent header
      window.addEventListener('scroll', () => {
        if (window.scrollY > 64) { // 4rem = 64px
          this.header.classList.add('scrolled');
        } else {
          this.header.classList.remove('scrolled');
        }
      });

      // Handle mobile menu
      this.menuToggle.addEventListener('click', () => {
        this.mobileMenu.classList.add('active');
      });

      this.menuClose.addEventListener('click', () => {
        this.mobileMenu.classList.remove('active');
      });

      // Close menu when clicking a link
      const menuLinks = this.mobileMenu.querySelectorAll('.header__mobile-menu-link');
      menuLinks.forEach(link => {
        link.addEventListener('click', () => {
          this.mobileMenu.classList.remove('active');
        });
      });

      // Handle search container
      this.searchToggle.addEventListener('click', () => {
        this.searchContainer.classList.add('active');
        setTimeout(() => this.searchInput.focus(), 100);
      });

      this.searchClose.addEventListener('click', () => {
        this.searchContainer.classList.remove('active');
      });

      // Close search on Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          if (this.searchContainer.classList.contains('active')) {
            this.searchContainer.classList.remove('active');
          }
          if (this.mobileMenu.classList.contains('active')) {
            this.mobileMenu.classList.remove('active');
          }
        }
      });
    }
  }

  new Header();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid"] && !Shopify.designMode) return;
  try {
    
  class ProductSlider {
    constructor(element) {
      this.slider = element;
      this.container = this.slider.querySelector('.product-grid__items');
      this.cards = this.slider.querySelectorAll('.product-card');
      this.prevBtn = this.slider.parentElement.querySelector('.product-grid__nav--prev');
      this.nextBtn = this.slider.parentElement.querySelector('.product-grid__nav--next');
      this.dotsContainer = this.slider.parentElement.parentElement.querySelector('[data-dots]');

      this.currentIndex = 0;
      this.totalSlides = Math.ceil(this.cards.length / this.getItemsPerPage());

      if (this.cards.length === 0) return;

      this.init();
    }

    init() {
      this.isCentered = this.slider.closest('[data-centered="true"]') !== null;

      this.createDots();
      this.updateButtons();
      this.attachEvents();
      this.updateCenteredState();
      this.updateSlider();

      let startX = 0;
      let isDragging = false;

      this.slider.addEventListener('touchstart', (e) => {
        startX = e.touches[0].clientX;
        isDragging = true;
      }, { passive: true });

      this.slider.addEventListener('touchend', (e) => {
        if (!isDragging) return;
        const endX = e.changedTouches[0].clientX;
        const diff = startX - endX;

        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            this.next();
          } else {
            this.prev();
          }
        }
        isDragging = false;
      });
    }

    getItemsPerPage() {
      if (window.innerWidth <= 600) return 1;
      if (window.innerWidth <= 900) return 2;
      return 3;
    }

    getGap() {
      if (window.innerWidth <= 600) return 16;
      if (window.innerWidth <= 900) return 24;
      return 32;
    }

    shouldShowSlider() {
      const itemsPerPage = this.getItemsPerPage();
      return this.cards.length > itemsPerPage;
    }

    updateCenteredState() {
      const wrapper = this.slider.closest('.product-grid__slider-wrapper');
      const showSlider = this.shouldShowSlider();

      if (this.isCentered && !showSlider) {
        wrapper?.classList.add('product-grid__slider-wrapper--centered');
        this.dotsContainer?.classList.add('product-grid__dots--hidden');
      } else {
        wrapper?.classList.remove('product-grid__slider-wrapper--centered');
        this.dotsContainer?.classList.remove('product-grid__dots--hidden');
      }
    }

    createDots() {
      if (!this.dotsContainer) return;

      this.totalSlides = Math.ceil(this.cards.length / this.getItemsPerPage());
      this.dotsContainer.innerHTML = '';

      if (this.totalSlides <= 1) return;

      for (let i = 0; i < this.totalSlides; i++) {
        const dot = document.createElement('button');
        dot.className = 'product-grid__dot';
        dot.type = 'button';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        if (i === 0) {
          dot.classList.add('active');
          dot.setAttribute('aria-selected', 'true');
        } else {
          dot.setAttribute('aria-selected', 'false');
        }
        dot.addEventListener('click', () => this.goToSlide(i));
        this.dotsContainer.appendChild(dot);
      }
    }

    attachEvents() {
      this.prevBtn?.addEventListener('click', () => this.prev());
      this.nextBtn?.addEventListener('click', () => this.next());

      window.addEventListener('resize', () => {
        const newTotal = Math.ceil(this.cards.length / this.getItemsPerPage());
        if (newTotal !== this.totalSlides) {
          this.totalSlides = newTotal;
          this.currentIndex = Math.min(this.currentIndex, this.totalSlides - 1);
          this.createDots();
          this.updateSlider();
        }
        this.updateCenteredState();
      });
    }

    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.updateSlider();
      }
    }

    next() {
      if (this.currentIndex < this.totalSlides - 1) {
        this.currentIndex++;
        this.updateSlider();
      }
    }

    goToSlide(index) {
      this.currentIndex = index;
      this.updateSlider();
    }

    updateSlider() {
      const itemsPerPage = this.getItemsPerPage();
      const cardWidth = this.cards[0].offsetWidth;
      const gap = this.getGap();
      const offset = -(this.currentIndex * itemsPerPage * (cardWidth + gap));

      this.container.style.transform = `translateX(${offset}px)`;
      this.updateButtons();
      this.updateDots();
    }

    updateButtons() {
      if (this.prevBtn) {
        const isDisabled = this.currentIndex === 0;
        this.prevBtn.disabled = isDisabled;
        this.prevBtn.setAttribute('aria-disabled', String(isDisabled));
      }
      if (this.nextBtn) {
        const isDisabled = this.currentIndex === this.totalSlides - 1;
        this.nextBtn.disabled = isDisabled;
        this.nextBtn.setAttribute('aria-disabled', String(isDisabled));
      }
    }

    updateDots() {
      if (!this.dotsContainer) return;

      const dots = this.dotsContainer.querySelectorAll('.product-grid__dot');
      dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('active', isActive);
        dot.setAttribute('aria-selected', String(isActive));
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-slider]').forEach(slider => {
      new ProductSlider(slider);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-main"] && !Shopify.designMode) return;
  try {
    
  class ProductMain {
    constructor() {
      this.container = document.querySelector('.product-main');
      if (!this.container) return;

      this.thumbnails = this.container.querySelectorAll('[data-thumbnail-index]');
      this.images = this.container.querySelectorAll('[data-image-index]');
      this.quantityInput = this.container.querySelector('[data-quantity-input]');
      this.minusBtn = this.container.querySelector('[data-quantity-minus]');
      this.plusBtn = this.container.querySelector('[data-quantity-plus]');

      this.variantInputs = this.container.querySelectorAll('[data-option-input]');
      this.variantIdInput = this.container.querySelector('[data-variant-id-input]');
      this.priceWrapper = this.container.querySelector('[data-price-wrapper]');
      this.addToCartBtn = this.container.querySelector('[data-add-to-cart]');
      this.addToCartText = this.container.querySelector('[data-add-to-cart-text]');

      const variantJson = this.container.querySelector('[data-variant-json]');
      try {
        this.variants = variantJson ? JSON.parse(variantJson.textContent) : [];
      } catch (e) {
        this.variants = [];
      }

      this.currency = document.documentElement.dataset.currency || 'EUR';
      this.locale = document.documentElement.lang || 'de';

      this.init();
    }

    init() {
      this.thumbnails.forEach(thumbnail => {
        thumbnail.addEventListener('click', () => {
          const index = thumbnail.dataset.thumbnailIndex;
          this.switchImage(index);
        });
      });

      if (this.minusBtn) {
        this.minusBtn.addEventListener('click', () => {
          const currentValue = this.getValidQuantity();
          if (currentValue > 1) {
            this.quantityInput.value = currentValue - 1;
          }
        });
      }

      if (this.plusBtn) {
        this.plusBtn.addEventListener('click', () => {
          this.quantityInput.value = this.getValidQuantity() + 1;
        });
      }

      if (this.quantityInput) {
        this.quantityInput.addEventListener('change', () => {
          this.quantityInput.value = this.getValidQuantity();
        });
      }

      this.variantInputs.forEach(input => {
        input.addEventListener('change', () => this.onVariantChange());
      });
    }

    getValidQuantity() {
      const val = parseInt(this.quantityInput.value, 10);
      return isNaN(val) || val < 1 ? 1 : val;
    }

    switchImage(index) {
      this.thumbnails.forEach(thumb => {
        thumb.classList.remove('active');
        thumb.setAttribute('aria-pressed', 'false');
      });
      if (this.thumbnails[index]) {
        this.thumbnails[index].classList.add('active');
        this.thumbnails[index].setAttribute('aria-pressed', 'true');
      }

      this.images.forEach(img => img.classList.remove('active'));
      if (this.images[index]) {
        this.images[index].classList.add('active');
      }
    }

    onVariantChange() {
      if (!this.variants || this.variants.length === 0) return;

      const selectedOptions = [];
      this.container.querySelectorAll('[data-option-input]:checked').forEach(input => {
        const position = parseInt(input.dataset.optionPosition, 10);
        selectedOptions[position - 1] = input.dataset.optionValue;
      });

      const matchedVariant = this.variants.find(variant => {
        return variant.options.every((opt, i) => opt === selectedOptions[i]);
      });

      if (!matchedVariant) {
        this.setUnavailable();
        return;
      }

      if (this.variantIdInput) {
        this.variantIdInput.value = matchedVariant.id;
      }

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', matchedVariant.id);
        window.history.replaceState({}, '', url);
      }

      this.updatePrice(matchedVariant);
      this.updateAddToCart(matchedVariant);

      if (matchedVariant.featured_image && matchedVariant.featured_image.position) {
        const imgIndex = matchedVariant.featured_image.position - 1;
        if (this.images[imgIndex]) {
          this.switchImage(imgIndex);
        }
      }
    }

    updatePrice(variant) {
      if (!this.priceWrapper) return;

      const priceEl = this.priceWrapper.querySelector('[data-price]');
      const compareEl = this.priceWrapper.querySelector('[data-compare-price]');
      const badgeEl = this.priceWrapper.querySelector('[data-discount-badge]');

      if (priceEl) priceEl.textContent = this.formatMoney(variant.price);

      const hasCompareAt = variant.compare_at_price && variant.compare_at_price > variant.price;

      if (hasCompareAt) {
        if (priceEl) priceEl.classList.add('product-main__price--sale');
        if (compareEl) {
          compareEl.textContent = this.formatMoney(variant.compare_at_price);
          compareEl.style.display = '';
        }
        if (badgeEl) {
          const percent = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
          badgeEl.textContent = '-' + percent + '%';
          badgeEl.style.display = '';
        }
      } else {
        if (priceEl) priceEl.classList.remove('product-main__price--sale');
        if (compareEl) compareEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }
    }

    formatMoney(cents) {
      try {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency
        }).format(cents / 100);
      } catch (e) {
        return (cents / 100).toFixed(2) + ' ' + this.currency;
      }
    }

    updateAddToCart(variant) {
      if (!this.addToCartBtn) return;

      const addText = this.addToCartBtn.dataset.textAvailable || 'In den Warenkorb';
      const soldOutText = this.addToCartBtn.dataset.textSoldOut || 'Ausverkauft';

      if (variant.available) {
        this.addToCartBtn.disabled = false;
        this.addToCartBtn.removeAttribute('aria-disabled');
        if (this.addToCartText) this.addToCartText.textContent = addText;
      } else {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.setAttribute('aria-disabled', 'true');
        if (this.addToCartText) this.addToCartText.textContent = soldOutText;
      }
    }

    setUnavailable() {
      if (!this.addToCartBtn) return;
      this.addToCartBtn.disabled = true;
      this.addToCartBtn.setAttribute('aria-disabled', 'true');
      if (this.addToCartText) {
        this.addToCartText.textContent = this.addToCartBtn.dataset.textSoldOut || 'Ausverkauft';
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    new ProductMain();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function loadRecommendations() {
      var container = document.querySelector('[data-recommendations]');
      if (!container) return;

      var section = container.closest('.product-recommendations');
      var productId = container.dataset.productId;
      if (!productId) {
        if (section) section.classList.add('product-recommendations--empty');
        return;
      }

      var sectionId = section ? section.dataset.sectionId : null;
      if (!sectionId) return;

      var url = '/recommendations/products?section_id=' + encodeURIComponent(sectionId) +
                '&product_id=' + encodeURIComponent(productId) +
                '&limit=4';

      fetch(url)
        .then(function(response) {
          if (!response.ok) return null;
          return response.text();
        })
        .then(function(html) {
          if (!html) {
            if (section) section.classList.add('product-recommendations--empty');
            return;
          }

          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var populated = doc.querySelector('[data-recommendations-populated]');

          if (populated && populated.children.length > 0) {
            container.innerHTML = populated.innerHTML;
          } else if (section) {
            section.classList.add('product-recommendations--empty');
          }
        })
        .catch(function(error) {
          console.error('Error fetching recommendations:', error);
          if (section) section.classList.add('product-recommendations--empty');
        });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', loadRecommendations);
    } else {
      loadRecommendations();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
